import { createRouter, createWebHistory } from 'vue-router';
import PaceCalculator from '@/views/PaceCalculator.vue';
import TrackCalculator from '@/views/TrackCalculator.vue';
import VO2MaxCalculator from '@/views/VO2MaxCalculator.vue';
import TreadmillCalculator from '@/views/TreadmillCalculator.vue';
import RacePage from '@/views/RaceViews.vue';

const routes = [
  {
    path: '/',//pace
    name: '페이스 계산기',
    meta: { class: "pace" },
    component: PaceCalculator,
  },
  {
    path: '/track',//track
    name: '400m 트랙',
    meta: { class: "track" },
    component: TrackCalculator,
  },
  {
    path: '/vo2max',
    name: 'VO2Max',
    meta: { class: "vo2max" },
    component: VO2MaxCalculator,
  },
  {
    path: '/treadmill',
    name: '트레드밀&러닝머신',
    meta: { class: "treadmill" },
    component: TreadmillCalculator,
  },
  {
    path: '/race',
    name: '대회정보',
    meta: { class: "race" },
    component: RacePage,
  },

  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
